import { cloneDeep } from "lodash";
/**
 * 删除值为null的属性
 * @param obj 源对象
 * @returns
 */
export function removeNullProperties(obj: Record<string, any>) {
  const temp = cloneDeep(obj);
  // 遍历对象的所有属性
  for (const key in temp) {
    if (temp[key] === null) {
      // 如果属性值为null，则删除该属性
      delete temp[key];
    } else if (Array.isArray(temp[key])) {
      // 过滤数组中的空值
      temp[key] = temp[key].filter((item: any) => {
        if (item !== null && item !== undefined) {
          if (
            typeof item === "object" &&
            Object.values(item).some((m) => m === null || m === void 0)
          ) {
            return false;
          }
          return true;
        }
        return false;
      }); // 过滤掉数组中的null元素
    }
  }
  return temp;
}
